import ChartSortButton from './ChartSortButton';
import { CHART_TYPES } from '../constants/chartTypes';
import { QueryType, TimeUnit } from '../../../utils/apollo/graphqlSchema';
import ChartTypeSelector from '../ChartTypeSelector';
import { useAppDispatch } from '../../../redux/hooks';
import { SingleSelectMenu } from '../../Dropdown';
import { setSingleDayLabelAction } from '../../../redux/slices/analyses';
import * as ChartControlBarUI from './ChartControlBarUI';
import { useChartContext } from '../ChartContext';

interface IProps {
  analysisId: string;
}

export default ({ analysisId }: IProps) => {
  const dispatch = useAppDispatch();
  const {
    metadata: { queryType, timeUnit, query },
    chartData,
    settings: { chartSettings },
  } = useChartContext();
  const { chartType, singleDayLabel } = chartSettings;
  const showChartTypeSelector = [
    QueryType.Expression,
    QueryType.Funnel,
    QueryType.Retention,
  ].includes(queryType);

  const showDateSelector =
    queryType === QueryType.Expression && timeUnit !== TimeUnit.AllTime;

  // query.includeMissingDates is only available for Expression
  const notIncludeMissingDates =
    query?.__typename === 'ExpressionQuery' && !query.includeMissingDates;

  const changeSelectedDate = (selectedDate: string) => {
    dispatch(
      setSingleDayLabelAction({
        analysisId,
        singleDayLabel: selectedDate,
      }),
    );
  };

  return (
    <ChartControlBarUI.ControlBarRow>
      {notIncludeMissingDates && <div>Excluding missing dates</div>}
      {showChartTypeSelector && <ChartTypeSelector />}
      {showDateSelector && chartData?.queryType === QueryType.Expression && (
        <SingleSelectMenu
          options={chartData.dates
            .map((date: string) => ({
              value: date,
              text: date,
            }))
            .reverse()}
          value={singleDayLabel}
          onChange={changeSelectedDate}
        />
      )}
      {chartType === CHART_TYPES.BAR_CHART && <ChartSortButton />}
    </ChartControlBarUI.ControlBarRow>
  );
};
